import { useNavigate } from '@tanstack/react-router';
import { FeedbackForm } from '@/components/FeedbackForm';
import { AccountContent } from '@/content/AccountContent';

export function Feedback() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    // Navigate back to account page after successful submission
    navigate({ to: '/account' });
  };

  return (
    <div className="w-full max-w-4xl mx-auto px-4 pb-8">
      <h1 className="font-field-74 text-h1 text-slate-50 mb-6">
        {AccountContent.feedback.title}
      </h1>

      <FeedbackForm onSuccess={handleSuccess} />
    </div>
  );
}
